module.exports = new __parcel__URL__("code-page-with-work-suggestions.tpl.22a912f2.svg").toString();